export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40596234071a267c0bc3d14db0841ec35d219be0fd&name=revalidateCommunity!'